export * from './index-custom';

// Re-export select Material icons here so consumers import from
// `@rhg/libs/material/icons` instead of `@mui/icons-material` directly
// (per the import convention / no-restricted-imports rule).
export {
    AddCircleOutline,
    CheckRounded,
    Login,
    Pause,
    PlayArrow,
    QrCode2,
} from '@mui/icons-material';
